import React, { useState } from "react";
import Header from "../components/Layout/Header";
import styles from "../styles/styles";
import Loader from "../components/Layout/Loader";
import ProfileSideBar from "../components/Profile/ProfileSidebar";
import ProfileContent from "../components/Profile/ProfileContent";
import { useSelector } from "react-redux";

const ProfilePage = () => {
  const { loading } = useSelector((state) => state.user);
  const [active, setActive] = useState(1);

  return (
    <div className="dashboard-page-wrapper">
      {loading ? (
        <Loader />
      ) : (
        <>
          <Header />
          <div className={`${styles.section} dashboard-flex-wrapper bg-[#f5f5f5] py-10`}>
            <div className="w-[50px] 800px:w-[335px] dashboard-sidebar sticky 800px:mt-0 mt-[18%]">
              <ProfileSideBar active={active} setActive={setActive} />
            </div>
            <div className="profile-content-wrapper flex-1">
              <ProfileContent active={active} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProfilePage;
